const e = {
  name: "ArrowUp",
  dimensions: { width: 29, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 29.1 40" style="enable-background:new 0 0 29.1 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18.5,40h-8V15.3l-4.9,4.9L0,14.5L14.5,0l14.5,14.5l-5.7,5.7l-4.9-4.9V40L18.5,40z M12.5,38h4V10.5l6.9,6.9
			l2.8-2.8L14.5,2.8L2.8,14.5l2.8,2.8l6.9-6.9V38z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as ArrowUp
};
